import getDateDebutFinEchances
  from '@/services/commande/echeancierFacturation/getDateDebutFinEchances';
import getDateFinEcheancierManuel
  from '@/services/commande/echeancierFacturation/getDateFinEcheancierManuel';
import { LISTE_UNITE_ECHEANCIER_FACTURATION, MOIS } from '@/configuration/devisConf';

export default function genererEcheancierManuel(
  lignesCommandes, datePremierAffichage, dateCommande, referenceEcheancier,
) {
  let unitePeriodicite = MOIS;
  if (lignesCommandes.length === 1) {
    const uniteFind = LISTE_UNITE_ECHEANCIER_FACTURATION.find((listeUnite) => {
      return listeUnite.code === lignesCommandes[0].uniteVente;
    });
    if (uniteFind) unitePeriodicite = uniteFind.code;
  }
  return {
    echeancierLignes: [],
    dateDebut: getDateDebutFinEchances(lignesCommandes, datePremierAffichage, dateCommande),
    dateFin: getDateFinEcheancierManuel(lignesCommandes),
    dateFinPremiereEcheance: null,
    quantitePeriodicite: 1,
    referenceEcheancier: referenceEcheancier,
    unitePeriodicite: unitePeriodicite,
    select: false,
  };
}
